let entity = "State"
export const GET_ALL =  `${process.env.REACT_APP_URL}${entity}/all`